import { UNDO_DEPTH } from './constants';

/** Previous states, oldest first. The newest entry is last. */
export type UndoStack<S> = readonly S[];

export interface UndoPop<S> {
  readonly state: S;
  readonly stack: UndoStack<S>;
}

/** Returns a new stack with `prevState` on top, keeping at most `UNDO_DEPTH` entries (oldest dropped). */
export function pushUndo<S>(stack: UndoStack<S>, prevState: S): UndoStack<S> {
  const next = [...stack, prevState];
  return next.length > UNDO_DEPTH ? next.slice(next.length - UNDO_DEPTH) : next;
}

/** Removes the newest entry. Returns undefined when the stack is empty. */
export function popUndo<S>(stack: UndoStack<S>): UndoPop<S> | undefined {
  if (stack.length === 0) return undefined;
  const state = stack[stack.length - 1] as S;
  return { state, stack: stack.slice(0, -1) };
}

export function canUndo<S>(stack: UndoStack<S>): boolean {
  return stack.length > 0;
}
